angular.module('mtic.components.modules.gr78')
.service('gr78MapItemFactory', function(
  GR78_ASSET_URL,
  EventManager,
  $log,
  $timeout,
  TIMING_CONSTANTS,
  language,
  DEV_VARIABLES,
  TeacherDataService,
  MapStateService,
  ModuleFilter
) {

    var currentActiveItem = null;

    var getIconFilename = function(item_info) {

      //assessments are easy
      if (item_info.resource_type === 'assessment') {
        if(item_info.config.assessment_type && item_info.config.assessment_type === 'formative'){
          if(item_info.complete && item_info.resourceState && item_info.resourceState.score_max >= 0.8){
            return 'formative_gold.png';
          }else if(item_info.complete){
            return 'formative_silver.png';
          }else if(!item_info.locked){
            return 'formative_unlocked.png';
          }else{
            return 'formative_locked.png';
          }
        }
        if (item_info.complete || item_info.config.assessment_type && item_info.config.assessment_type === 'summative' )
        {
          return 'assessment_complete.png';
        }
        return 'assessment.png';
      }
      if (!item_info.display)
      {
        item_info.display = {};
      }


      //get the color from item_info.display.color, fall back to "red" if it isn't defined
      var color_string = (item_info.display.color !== undefined) ? item_info.display.color : 'red';

      var suffix;
      if (item_info.locked) {
        suffix = "_locked";
      } else {
        if (!item_info.resourceState || !item_info.resourceState.complete) {
          suffix = "_0"
        } else {

          var count = 0;

          if (item_info.resourceState.score_max >= 1)
          {
            count = 3;
          } else if (item_info.resourceState.score_max >= 0.8)
          {
            count = 2;
          } else if (item_info.resourceState.score_max >= 0.5)
          {
            count = 1;
          }
          if (color_string === 'blue') {
            count = 1//Math.min(count, 1);
          }
          count = Math.max(0, count);
          suffix = "_" + count;

        }
      }
      var filename = "item_" + color_string + suffix + ".png";
      return filename;
    };
    return {
      unlockedByAgenda: false,
      getCurrentActiveItem: function() {
        return currentActiveItem;
      },
      createMapItem: function MapItem(item_info, eventManager) {
        var scale = 1.0, alwaysHideTooltip = false;
        // Grab Relevant data for item

        this.id = item_info.id;
        this.name = item_info.name;
        this.slug = item_info.slug;
        this.type = item_info.resource_type;
        this.studentWork = item_info.studentWork;
        this.config = item_info.config;

        this.container = {};
        if (item_info.content)
        {
          this.container = item_info.content.container;
        }
        this.complete = item_info.complete;
        this.locked = (item_info.parent_resource_id > 2252 && item_info.parent_resource_id < 2258) ? false : item_info.locked//item_info.parent_resource_id === 1114 && window.location.href.indexOf('locxalhost') > -1 ? false :item_info.locked;//add this for unlocked m0: item_info.parent_resource_id === 1114 ? false :
        this.unlocked_by = item_info.unlocked_by;
        this.content = item_info.content;
        this.verletBody = null;
        this.parentItem = null;

        var agenda_highlight = null;

        if (DEV_VARIABLES.RESOURCES.MARK_COMPLETE.indexOf(this.slug ) > -1)
        {
          this.complete = true;
        }
        //Handle group stuff!!
        if (item_info.children && item_info.children.length > 0) {
          this.locked = true;
          var i = 0;
          for (i = 0; i < item_info.children.length; i++) {
            this.locked = this.locked && item_info.children[i].locked;
          }
          item_info.locked = this.locked;


          this.complete = true;
          for (i = 0; i < item_info.children.length; i++) {
            this.complete = this.complete && item_info.children[i].complete;
          }
          item_info.complete = this.complete;
          item_info.resourceState = {};
          item_info.resourceState.score_max = this.complete ? 1 : 0;
        }

        if(DEV_VARIABLES.RESOURCES.UNLOCK_THESE.indexOf(this.slug ) > -1) {
          this.locked = false;
        }
        if(DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(this.slug ) > -1 || !ModuleFilter.checkAvailable(item_info)) {
          this.locked = true;
        }

        var sprite, icon;
        var startClickPos = {
          x: 0,
          y: 0
        };

        this.setDelegate = function(del) {
          var boundClick = (function(e) {
            del(this.slug);
          }).bind(this);
          sprite.on('pointertap', boundClick)
            //sprite.on('click', );
        }

        var getItemDisplayName = function() {
          var itemDisplayName;
          if (item_info.display && item_info.display.nameLangId) {
            itemDisplayName = language.get(item_info.display.nameLangId)
          } else {
            /*
            if(item_info.slug.indexOf('gr78_m4') > -1 || item_info.slug.indexOf('g78_m4') > -1){
              itemDisplayName = language.get(item_info.slug+'_short', null, true)
            }else{
              itemDisplayName = language.get(item_info.slug, null, true)
            }*/
            itemDisplayName = language.get(item_info.slug, null, true);
          }
          if ((!itemDisplayName || itemDisplayName === item_info.slug) && item_info.name) {
            itemDisplayName = item_info.name;
          }
          return itemDisplayName;
        }

        this.updateIcon = function() {
          if (this.type === 'symlink') {
            icon.texture = PIXI.loader.resources[GR78_ASSET_URL + "symlink.png"].texture;
          } else if(PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)]) {
            icon.texture = PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)].texture;
          }
        }
        this.buildTooltip = function() {
          if (tooltip !== null && tooltip !== undefined) {
            sprite.removeChild(tooltip);
            tooltip.interactive = false;
          }
          tooltip = new PIXI.Sprite();

          // Text Information
          var textInfo = new PIXI.Text(getItemDisplayName(), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: 24,
            fill: 0xFFFFFF,
            dropShadow: true,
            dropShadowDistance: 1,
            dropShadowBlur: 0,
            wordWrap: true,
            wordWrapWidth: 200
          });

          var tooltip_graphics = new PIXI.Graphics();

          var drawTooltipContainer = function() {
            tooltip_graphics.clear();
            // Draw Text Bubble that wraps around the text
            tooltip_graphics.lineStyle(0);
            tooltip_graphics.beginFill(0x3B5763);
            tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
            tooltip_graphics.endFill();

            // Draw Triangle pointing to planet
            tooltip_graphics.beginFill(0x3B5763);
            tooltip_graphics.moveTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2), textInfo.y - 18);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) + 5, textInfo.y - 10);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            tooltip_graphics.endFill();

            tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
            tooltip_graphics.y = icon.height / 2 + 10;

          }

          drawTooltipContainer();

          tooltip.addChild(tooltip_graphics);
          tooltip_graphics.addChild(textInfo);
          sprite.addChild(tooltip);
          tooltip.interactiveChildren = false;
          tooltip.visible = item_info.slug.indexOf('ocmt_hse') > -1 || (item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative) ? true : false;

          eventManager.listen('language:change', function() {
            if (textInfo === undefined) {
              return;
            }
            textInfo.setText(getItemDisplayName());
            drawTooltipContainer();
          })

          eventManager.listen('module:change:meta', function(){
            that.hideAgendaHighlight();
          })

          var updateItemInfoComplete = function(existsItem){
            var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
            item_info.complete = existsItem.completed;
            item_info.resourceState = {complete:existsItem.completed};
            item_info.resourceState.score_max =  exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
            item_info.score = item_info.resourceState.score_max;
          }

          eventManager.listen("teacherStudentWorkspace:studentFilter:change",function(e,eventData){
            var filteredList = eventData.list||[];
            var doneItemsList = [];
            if(filteredList  && filteredList.length>0){
              doneItemsList = _.filter(filteredList,function(item){
                return item.resource_id === item_info.id;
              });
            }

            if(doneItemsList.length > 0){ 
              var exists_info = {score: null, completed: false}
              _.each(doneItemsList, function(existsItem){
                exists_info.completed = exists_info.completed || existsItem.completed
                exists_info.score = exists_info.score ? Math.max(exists_info.score, existsItem.score) : existsItem.score;
              })
              updateItemInfoComplete(exists_info);
            }else{
              item_info.complete = false;
              item_info.resourceState = {complete:false, score_max: null};
              item_info.score = null;
            }
            if (item_info.resource_type === 'symlink' &&  PIXI.loader.resources[GR78_ASSET_URL + "symlink.png"]) {
              icon.texture = PIXI.loader.resources[GR78_ASSET_URL + "symlink.png"].texture;
            }
            else if(PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)]){
              icon.texture = PIXI.loader.resources[GR78_ASSET_URL + getIconFilename(item_info)].texture;
            }
          });
        }

        var unclickableTypes = ['symlink']
        this.onButtonClick = function() {

          if (unclickableTypes.indexOf(this.type) > -1) {
            return;
          }


          //Cancel click events if they dragged more than 100 pixels
          var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
          if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
            return;
          }

          $log.debug('[[mapItemFactory]] clicking on', item_info, 'LOCK STATUS:::::::::::::', this.locked);
          if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1) {
            if (!TeacherDataService.isTeacherModuleView){
              this.locked = false;
            }
            else{
              this.locked = true;
            }
          }
          if(!ModuleFilter.checkAvailable(item_info)){
            this.locked = true;
            item_info.locked = true;
            eventManager.broadcast('display-maintenance-message', item_info.slug);
          }

         // if (!this.locked) {
            $timeout(function() {
              sprite.scale.set(1*scale, 1*scale);
              // var item_evt_info = {
              //   slug : item_info.slug,
              //   id : item_info.id
              // };
              eventManager.broadcast('module:stop:pan')
              eventManager.broadcast('module:select:resource', item_info);
            }, TIMING_CONSTANTS.INSTANT)
         // }
        };

        this.unlock = function(from_agenda) {
          if(DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug ) > -1 || !ModuleFilter.checkAvailable(item_info) ||
          (item_info.resource_type === 'assessment' && item_info.resourceState && item_info.resourceState.complete && !from_agenda)) {
            return
          }
          item_info.locked = false;
          this.locked = false;
          this.updateIcon();
        };

        this.lock = function() {
          if(this.unlockedByAgenda){
            return;
          }
          item_info.locked = true;
          this.locked = true;
          this.updateIcon();
        }

        this.getItemInfo = function() {
          return item_info;
        }


        this.setItemComplete = function() {
          this.updateIcon();
          if (this.studentWork) {
            this.studentWork.completions++;
          } else {
            this.studentWork = {
              completions: 1,
            };
          }
        }

        //For setting up verlet links to items inside a folder
        //items in minimized folders should verlet links to their parent
        this.getLinkedBody = function() {
          if (this.shouldBeOnMap()) {
            return this.verletBody;
          } else {
            return this.parentItem.getLinkedBody();
          }
        }

        //Map items inside mimized folder items get ignored
        this.shouldBeOnMap = function() {
          if (this.parentItem !== null) {
            return this.parentItem.isExpanded;
          } else {
            return this.isExpanded === true ? false : true;
          }
        }

        this.showHighlight = function() {
          if (this.type === 'symlink') {
            return;
          }
          if (tooltip && !alwaysHideTooltip) {
            tooltip.visible = true;
          }
          sprite.scale.set(1.1*scale, 1.1*scale);
          if (sprite.parent !== null) {
            sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
          }
        }

      this.undoAgendaHighlight = function() {}


      this.selection_graphic=null;
      this.highlight_graphic=null;
      var that = this;
      var is_item_selected;
      this.showAgendaHighlight = function(force, is_selection) {
        // $log.log('HIGHGLIGHT SELECTION : ' , this.type)
        if(this.highlight_graphic===null && is_selection){
          // $log.log('show agenda highlight', this.slug, is_selection)
          var radius =  this.type === 'assessment' ? 90 : 50;
          this.highlight_graphic = new PIXI.Graphics();
          this.highlight_graphic.lineStyle(33, 0x33CCFF,1)
          this.highlight_graphic.drawCircle(0, 0, radius)
          this.highlight_graphic.interactive = false;
          this.highlight_graphic.scale.set(0.75*scale,0.75*scale);
          this.highlight_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
          icon.addChildAt(this.highlight_graphic, 0);
        }else if (!is_selection && this.selection_graphic === null && (force !== false)){
          // $log.log('show agenda selection', this.slug, is_selection)
          is_item_selected = is_selection;
          var scale_size =  this.type === 'assessment' ? 2.5 : 0.75;
          this.selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
          this.selection_graphic.anchor.set(0.5,0.5);
          this.selection_graphic.scale.set(scale_size*scale,scale_size*scale);
          this.selection_graphic.interactive = false;
          this.selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
          icon.addChild(this.selection_graphic);
        }else if(!force){
          // $log.log('from toggle agenda selection', this.slug, is_selection)
          that.hideAgendaHighlight();
        }
      }
      this.hideAgendaHighlight = function(from_item_highlight) {
        // $log.log('hide agenda highlight', this.slug, from_item_highlight)
        if(from_item_highlight && this.highlight_graphic !== null){
          icon.removeChild(this.highlight_graphic);
          this.highlight_graphic = null;
        }if (!from_item_highlight && this.selection_graphic !== null){
          icon.removeChild(this.selection_graphic);
          this.selection_graphic = null;
        }
      }

      this.hideHighlight = function() {
        if (tooltip && !alwaysHideTooltip) {
          tooltip.visible = item_info.slug.indexOf('ocmt_hse') > -1 || (item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative)  ? true : false;
        }
        sprite.scale.set(1*scale, 1*scale);
      }

      this.setScale = function(scaleToBeSet){
        scale = scaleToBeSet;
        sprite.scale.set(scale,scale);
      }

      this.alwaysHideTooltip = function(){
        alwaysHideTooltip = true;
        tooltip.visible = false;
      }

      eventManager.listen('unlock-item', function(e, slug){
        if(slug === item_info.slug){
          that.unlock(true)
        }
      })

        this.pointerdown = function() {
            sprite.scale.set(0.9*scale, 0.9*scale);
            startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
          }
          /**
           * Tooltip setup
           */
        var tooltip;

        icon = new PIXI.Sprite();
        icon.anchor.set(0.5, 0.5);
        sprite = new PIXI.Sprite();
        this.sprite = sprite;

        var mouseOver = this.showHighlight.bind(this);
        sprite.on('mouseover', function() {
          mouseOver();
        });

        var mouseOut = this.hideHighlight.bind(this);
        sprite.on('pointerout', function() {
          mouseOut();
        });

        var pointerdown = this.pointerdown.bind(this);
        sprite.on('pointerdown', function() {
          pointerdown();
        });

        if (item_info.resource_type !== "group") {
          var boundClick = this.onButtonClick.bind(this);
          sprite.on('pointertap', boundClick);
        } else if (item_info.resource_type !== 'symlink') {
          this.open = false;
        }

        this.updateIcon();
        if (this.type === "group") {
          var bg = new PIXI.Sprite(icon.texture);
          bg.width += 20;
          bg.height += 20;

          bg.anchor.set(0.5, 0.5);
          sprite.addChild(bg);
        }
        sprite.addChild(icon);


        if (item_info.display.position !== undefined) {
          var divideBy = item_info.slug.indexOf("_g78_m0_")>-1?1:5;
          var startPosx = item_info.slug.indexOf("_g78_m0_")>-1?1300:0;
          var startPosY = item_info.slug.indexOf("_g78_m0_")>-1?300:0;
          sprite.position.set(startPosx + item_info.display.position.x/divideBy, startPosY + item_info.display.position.y/divideBy);
        } else {
          sprite.position.set(0, 0);
        }
        sprite.interactive = true; //!item_info.locked;
        sprite.buttonMode = true;
        this.buildTooltip();
        //for testing...
        //this.unlock();

      }
    }
  });
